import { ClassConstructor, plainToInstance } from "class-transformer";
import { validate } from "class-validator";
import { formatErrorMessage } from "../utils/errorMessageUtils";
export class AbstractJSONModel {
  static fromJSON<T extends object>(newObject: any): T {
    const me: any = this;
    const o: any = plainToInstance(me, newObject);

    // validate(o as T).then((errors) => {
    //   // errors is an array of validation errors
    //   if (errors.length > 0) {
    //     console.error("validation failed. errors: ", errors);
    //   }
    // });

    return o as T;
  }

  static async fromJSONArray<T extends object>(newObjects: any[]): Promise<T[]> {
    const me: ClassConstructor<T> = this as any;
    const returnarray: T[] = [];
    for (const newObject of newObjects) {
      const o: T = plainToInstance(me, newObject, { enableImplicitConversion: true });
      await validate(me.name, o);
      // if (validationErrors.length > 0) {
      //   console.error("validation failed. errors: ", validationErrors, o);
      // }

      returnarray.push(o);
    }
    return returnarray;
  }

  static async validateObject<T extends object>(object: any): Promise<string> {
    return await validate(object as T).then((errors) => {
      // errors is an array of validation errors
      if (errors.length > 0) {
        // eslint-disable-next-line no-console
        console.error("Object validation failed. errors: ", errors);
        let errorMessage = "";
        errors.forEach((error) => {
          if (error.constraints) {
            const arr = JSON.stringify(error.constraints).split("\":\"");
            if (arr.length > 1) {
              errorMessage += formatErrorMessage(arr[1]);
            }
          }
        });
        return errorMessage;
      } else {
        return "";
      }
    });
  }
}
